import React, { useEffect, useRef, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
    setComments, checkedState, unCheckedState, checkedAllState, unCheckedAllState, SingleApproveOrRejectAsync
} from './ExpenseApprovalSlice';
import moment from 'moment';
import '../../../common/css/timeLive.css'
import './ExpenseApproval.css'
import { ShowSwalWithConfirmationMessage } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import { ExpenseApprovalClass } from './interfaces/ExpenseApprovalClass';
import ExpenseApprovalPrintForm from './ExpenseApprovalPrintForm';
import { formatDateWithDateAndMonthName, FormatInvoiceDecimalNumber, determineCultureFormat, getValueFromResource } from '../../../common/timeLiveFunction';
import { format} from "date-fns"

const ExpenseApprovalItem = (props: any) => {
    const { expenseApprovalList, t, IsEdit } = props;
    const { CurrentCultureName, includeDateRange, startExpenseApprovalDate, endExpenseApprovalDate, Employeesdata, Projectdata } = useAppSelector((state) => state.expenseApproval);
    const {decimalPlaces, cultureInfoName} = useAppSelector((state)=> state.globalState);
    const popupRef = useRef<any>(null);
    const approvedButtonRef = useRef<any>(null);
    const rejectedButtonRef = useRef<any>(null);
    const modelRef = useRef<any>(null);
    const [id, setId] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [showPrint, setShowPrint] = useState(false);
    const [data, setData] = useState({
        expenseApprovalObject: {},
        filterProjects: '',
        filterEmployees: ''
    });

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (modalIsOpen) {
            if (modelRef.current) {
                modelRef.current.click();
            }
        }
    }, [modalIsOpen])

    const handleCommentsChange = (e: any, AccountEmployeeExpenseSheetId: any) => {
        dispatch(setComments({ AccountEmployeeExpenseSheetId: AccountEmployeeExpenseSheetId, Comments: e.target.value }))
    };

    const handleButtonClick = (e: any, AccountEmployeeExpenseSheetId: any) => {
        let id = e.currentTarget.id;
        ShowSwalWithConfirmationMessage(`Are you sure you want to ${id} this record?`, "", `Yes, Proceed`)
            .then((result) => {
                if (result) {
                    const foundItems = expenseApprovalList.filter((item: any) => item.AccountEmployeeExpenseSheetId === AccountEmployeeExpenseSheetId);
                    if (foundItems) {
                        dispatch(SingleApproveOrRejectAsync({ List: foundItems, id: id, IncludeDateRange: includeDateRange, ExpenseEntryStartDate: startExpenseApprovalDate, ExpenseEntryEndDate: endExpenseApprovalDate }))
                            .unwrap()
                            .then((originalPromiseResult) => {
                                originalPromiseResult.StatusCode === "200" ?
                                    ShowToast(`${id === "Approve" ? "Approved" : "Rejected"} Successfully`, 'Success', "success", "toast-top-right") :
                                    ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                            })
                            .catch((rejectedValueOrSerializedError) => {

                            })
                    }
                }
            })
            .catch((error) => {
            });
    };

    const renderEmployeeNameWithSystemApproverType = (expenseApproval: ExpenseApprovalClass) => {
        let SystemApproverType: string = "";
        let SystemApproverTypeToolTip: string = "";
        if (expenseApproval.SystemApproverTypeId == 1) {
            SystemApproverType = "(TL)";
            SystemApproverTypeToolTip = "Team Lead";
        }
        else if (expenseApproval.SystemApproverTypeId == 2) {
            SystemApproverType = "(PM)";
            SystemApproverTypeToolTip = "Project Manager";
        }
        else if (expenseApproval.SystemApproverTypeId == 3) {
            SystemApproverType = "(SE)";
            SystemApproverTypeToolTip = "Specific Employee";
        }
        else if (expenseApproval.SystemApproverTypeId == 4) {
            SystemApproverType = "(EU)";
            SystemApproverTypeToolTip = "External User";
        }
        else if (expenseApproval.SystemApproverTypeId == 5) {
            SystemApproverType = "(EM)";
            SystemApproverTypeToolTip = "Employee Manager";
        }
        return (
            <>
                <a className='text-dark fw-bold d-block mb-1 text-hover-primary custom-pointer-cursor' onClick={() => ShowPrint(expenseApproval)} >
                    {expenseApproval.EmployeeName} {SystemApproverType}
                </a>
                <span style={{ color: '#7b8ba6', fontSize: 11,  display: 'inline-flex', alignItems: 'center' }} >
                    <i className="ki-outline ki-calendar text-gray fs-4 me-1 "></i>
                    {/* {moment.parseZone(expenseApproval.ExpenseSheetDate).format('DD MMM yy')} */}
                    {formatDateWithDateAndMonthName(expenseApproval.ExpenseSheetDate, cultureInfoName.toString())}
                </span>
            </>
        );
    }

    const ShowPrint = (expenseApproval: ExpenseApprovalClass) => {
        const commaSeparatedEmployeeValues = Employeesdata.some((item: any) => item.isSelected === 1) ? Employeesdata.filter((item: any) => item.isSelected == 1).map((item: any) => item.value).join(', ') : "0";
        const commaSeparatedProjectValues = Projectdata.some((item: any) => item.isSelected === 1) ? Projectdata.filter((item: any) => item.isSelected == 1).map((item: any) => item.value).join(', ') : "0";
        setData({
            ...data,
            expenseApprovalObject: expenseApproval,
            filterProjects: commaSeparatedProjectValues,
            filterEmployees: commaSeparatedEmployeeValues
        });
    }

    useEffect(() => {
        if (Object.keys(data.expenseApprovalObject).length > 0) {
            setShowPrint(true);
        }
    }, [data])

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    }

    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    }

    return (
        <>
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1">
                <thead>
                    <tr className="thHeading align-middle">
                        {IsEdit ? (
                            <th className='w-25px'>
                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                    <input
                                        className='form-check-input'
                                        type='checkbox'
                                        checked={expenseApprovalList.every((item: any) => item.isSelected === 0) ? false :
                                            (expenseApprovalList.every((item: any) => item.isSelected === 1 ? true : false))
                                        }
                                        onChange={handleSelectAllChange}
                                    />
                                </div>
                            </th>
                        ) : null}
                        <th className='col'>
                            {/* {t('Employee Name')} */}
                            {getValueFromResource('Employee Name', dispatch, t)}
                        </th>
                        <th className='col'>
                            {/* {t('Description')} */}
                            {getValueFromResource('Description', dispatch, t)}
                        </th>
                        <th className='col'>
                            {/* {t('Amount')} */}
                            {getValueFromResource('Amount', dispatch, t)}
                        </th>
                        <th className='col'>
                            {/* {t('Billable')} */}
                            {getValueFromResource('Billable Amount', dispatch, t)}
                        </th>
                        <th className='col'>
                            {/* {t('NonBillable')} */}
                            {getValueFromResource('NonBillable Amount', dispatch, t)}
                        </th>
                        {IsEdit ? (
                            <th className='w-250px'></th>
                        ) : null}
                        <th className='w-25px text-center'></th>
                    </tr>
                </thead>
                <tbody>
                    {expenseApprovalList.length > 0 && expenseApprovalList.map((expenseApproval: any, i: any) => (
                        (expenseApproval.isFiltered === 1 || expenseApproval.isFiltered === -1) && (
                            <tr key={i}>
                                {IsEdit ? (
                                    <td>
                                        <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                            <input
                                                type="checkbox"
                                                className="form-check-input widget-9-check "
                                                checked={expenseApproval.isSelected == 0 ? false : true}
                                                onChange={(e) => { handleCheckboxChange(e, expenseApproval.AccountEmployeeExpenseSheetId) }}
                                            />
                                        </div>
                                    </td>
                                ) : null}
                                <td>
                                    {renderEmployeeNameWithSystemApproverType(expenseApproval)}
                                </td>
                                <td>
                                    {expenseApproval.Description !== "" ? (
                                        expenseApproval.Description

                                    ) : null}
                                </td>
                                <td>
                                    {/* {`${expenseApproval.BaseCurrencyCode} ${expenseApproval.Amount ? expenseApproval.Amount.toLocaleString(CurrentCultureName, { minimumFractionDigits: 2 }) : '0.00'}`} */}
                                    {`${expenseApproval.BaseCurrencyCode} ${expenseApproval.Amount ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), expenseApproval.Amount, decimalPlaces) : FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0.00, decimalPlaces)}`}
                                </td>
                                <td>
                                    {`${expenseApproval.BaseCurrencyCode} ${expenseApproval.billableamount ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), expenseApproval.billableamount, decimalPlaces) : FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0.00, decimalPlaces)}`}
                                </td>
                                <td>
                                    {`${expenseApproval.BaseCurrencyCode} ${expenseApproval.Nonbillableamount ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), expenseApproval.Nonbillableamount, decimalPlaces) : FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0.00, decimalPlaces)}`}
                                </td>
                                {IsEdit ? (
                                    <td className='p-0 m-0'>
                                        <button
                                            id="Approve"
                                            ref={approvedButtonRef}
                                            className={`btn btn-outline hover btn-sm btn-outline me-0 mb-0 btn-active-light-dark  me-1`}
                                            style={{ borderColor: 'green', color: 'green' }}
                                            onClick={(e: any) => handleButtonClick(e, expenseApproval.AccountEmployeeExpenseSheetId)}
                                        >
                                            <i className="bi bi-check iconApprove p-0"></i>
                                            <span style={{ color: '#009688' }}>
                                                {/* {t('Approved')} */}
                                                {getValueFromResource('Approve', dispatch, t)}
                                            </span>
                                        </button>
                                        <button
                                            id="Reject"
                                            ref={rejectedButtonRef}
                                            className={`btn btn-outline btn-sm btn-outline me-0 mb-0 btn-active-light-dark`}
                                            style={{ borderColor: 'red', color: 'red' }}

                                            onClick={(e: any) => handleButtonClick(e, expenseApproval.AccountEmployeeExpenseSheetId)}
                                        >
                                            <i className="bi bi-x iconReject p-0"></i>
                                            <span style={{ color: '#E53935' }}>
                                                {/* {t('Rejected')} */}
                                                {getValueFromResource('Reject', dispatch, t)}
                                            </span>
                                        </button>
                                    </td>
                                ) : null}
                                <td>
                                    <div className="btn-group" style={{ float: 'right' }}>
                                        <a
                                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            data-tooltip-id="tooltip-Description"
                                            data-tooltip-content=
                                            // {t("Approvers Comment")}
                                            {getValueFromResource('Approvers Comment', dispatch, t)}
                                            data-tooltip-place="bottom">
                                            <i className="bi bi-chat-square-text fs-3 iconColor"></i>
                                        </a>
                                        <ul className="dropdown-menu menu-column menu-rounded menu-gray-600 px-4 py-4 fs-2 w-300px" role="menu">
                                            <div className='menu-item text-gray-800'>
                                                <div className="dropdown-menu-item">
                                                    <textarea
                                                        placeholder=
                                                        // {t("Your comments here...")}
                                                        {getValueFromResource('Your comments here...', dispatch, t)}
                                                        className="form-control fs-7 fw-normal"
                                                        rows={4}
                                                        style={{ borderRadius: 2 }}
                                                        onChange={(e) => handleCommentsChange(e, expenseApproval.AccountEmployeeExpenseSheetId)}
                                                        value={expenseApproval.Comments}
                                                    />
                                                </div>
                                            </div>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        )
                    ))}
                </tbody>
            </table>
            {expenseApprovalList.length === 0 &&
                <div className=''>
                    <p className='noDataFound'>
                        {/* {t('No Record Found')} */}
                        {getValueFromResource('No Record Found', dispatch, t)}
                    </p>
                </div>
            }
            {showPrint &&
                <ExpenseApprovalPrintForm data={data} onSetShowPrint={setShowPrint}></ExpenseApprovalPrintForm>
            }
        </>
    )
}

export default ExpenseApprovalItem